<template>
  <div class="project-appoint-info-confirm" id="project-appoint-info-confirm">
    <div class="content-box">
      <div class="title-top">
        <span class="font-title">{{ title }}</span>
      </div>
      <div class="baseinfo-box">
        <span class="project-title">项目信息</span>
        <van-cell-group>
          <div
            class="list-panel"
            v-for="(item, index) in listData"
            :key="index"
          >
            <van-cell
              v-if="item.isShow"
              :title="item.label"
              :value="item.defaultVal"
            ></van-cell>
          </div>
        </van-cell-group>
        <span class="project-title">附件材料列表</span>
        <van-cell-group>
          <div
            class="file-list-panel"
            v-for="(item, index) in fileList"
            :key="index"
          >
            <van-cell :title="item.ZLMC"></van-cell>
            <van-cell
              v-if="!item.FJLIST || item.FJLIST.length == 0"
              class="input-upload"
              title="暂无材料"
            ></van-cell>
            <van-cell
              title-style="word-break: break-all;min-width: 300px;"
              v-for="(file, idx) in item.FJLIST"
              :key="idx"
              class="input-upload"
              :title="file.FJNAME"
              value="已上传"
            ></van-cell>
          </div>
        </van-cell-group>
      </div>
    </div>
    <div class="btn-group">
      <van-button plain type="info" @click="toPrev">上一步</van-button>
      <van-button type="info" @click="toNext">确认发布</van-button>
    </div>
    <van-dialog v-model="showSuccess" show-cancel-button
      confirm-button-text='查看申请详情' confirm-button-color='#1D84FF'
      cancel-button-text='继续发布'
      @confirm="queryDetail" @cancel="cancelDialog"
    >
      <div class="success-dialog">
        <img src="@/assets/img/opinionPublish/success_icon.png" />
        <div class="text">提交成功</div>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import api from "@/utils/api/appoint";
export default {
  components: {},
  name: "ProjectAppointInfoConfirm",
  props: {},
  data() {
    return {
      listData: [], // 列表数据
      baseInfo: {}, // 基础信息对象
      title: "",
      fileList: [], // 附件材料列表
      testData: [],
      rid: this.$route.params.id,
      showSuccess: false,
    };
  },
  watch: {},
  computed: {
    ...mapGetters("form", ["getFormConfigByName", "getSubmitFormConfig"]),
  },
  methods: {
    ...mapMutations("form", ["setFormConfig", "setFormConfigPermission"]),
    getData() {
      this.listData = [];
      const commonFormFinal = this.getFormConfigByName("CommonFormFinal");
      const commonPermission = commonFormFinal?.permission;
      const commonData = commonFormFinal?.data;
      for (let key in commonPermission) {
        if (Object.hasOwnProperty.call(commonData, key)) {
          //data有key才设置
          commonPermission[key].defaultVal = commonData[key];
          //项目名称在title显示
          if (key == "GCMC") {
            this.title = commonData[key];
          }
        }
        if (key != "GCMC") {
          this.listData.push(commonPermission[key]);
        }
      }
      // 测绘事项
      const cascaderSelect = this.getFormConfigByName("CascaderSelect");
      const cascaderData = cascaderSelect?.data?.CLSX;
      const CLSXName = [];
      let cldw = "";
      if (cascaderData) {
        for (const data of cascaderData) {
          CLSXName.push(data.CLSXName);
          cldw = data.cldw;
        }
      }
      let CLSXData = {
        label: "测绘事项",
        isShow: true,
        defaultVal: CLSXName.join(" "),
      };
      let cldwData = {
        label: "委托测绘单位",
        isShow: true,
        defaultVal: cldw,
      };
      this.listData.push(CLSXData);
      this.listData.push(cldwData);
      //材料
      const fileTable = this.getFormConfigByName("FileTable");
      const fileTableData = fileTable.data.files;
      this.fileList = fileTableData;
    },
    toPrev() {
      // 上一步
      this.$router.push({
        name: "FileTable",
        params: {
          to: "confirm",
        },
      });
      // this.$router.go(-1)
    },
    toNext() {
      // 确认发布
      this.$dialog
        .confirm({
          title: "- 温馨提示 -",
          message: "确认提交?",
          confirmButtonColor: "#1D84FF",
        })
        .then(() => {
          // on confirm
          this.toSubmit();
        })
        .catch(() => {
          // on cancel
        });
    },
    tempSave() {
      // 暂存
    },
    toSubmit() {
      const toast = this.$toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        message: "上传中",
      });
      const data = this.getSubmitFormConfig("information");
      api
        .submitEntrust({ data: data, type: 1, moduleName: "PreBusiness" })
        .then((res) => {
          toast.clear();
          if (res.code == 0) {
            this.queryDetail();
          } else {
            this.$toast.fail("上传失败");
          }
        })
        .catch(() => {
          toast.clear();
          this.$toast.fail("上传失败");
        });
    },
    queryDetail() {
      this.$router.push({
        name: "projectProgressHome",
        query: {
          title: '进度查询'
        }
      })
    },
    cancelDialog() {
      console.log('cancelDialog - 继续发布')
      this.$router.go(-5)
    },
  },
  created() {},
  mounted() {
    if (this.rid) {
      api.getDataByTemporarilyToCode({ rid: this.rid }).then((res) => {
        this.setFormConfig(JSON.parse(res.data));
        api.getComponentConfig().then((res) => {
          this.setFormConfigPermission({
            CommonFormFinal: res.data[1].permission,
          });
        });
        this.getData();
      });
    } else {
      this.getData();
    }
    //提交成功退回到首页
    // this.$bus.$off('onBack')
    // this.$bus.$on('onBack', () => {
    //   if (window.__wxjs_environment === 'miniprogram') {
    //     wx.miniProgram.navigateBack({
    //       delta: 1
    //     })
    //   } else {
    //     this.$router.go(-5)
    //   }
    // })
  },
};
</script>
<style lang="scss" scoped>
.project-appoint-info-confirm {
  .content-box {
    margin-bottom: 70px;
    .title-top {
      height: 15vw;
      line-height: 15vw;
      padding: 0 3vw;
      background-color: #ffffff;
      .font-title {
        font-weight: bold;
        color: #1d84ff;
      }
    }
    .baseinfo-box {
      .project-title {
        padding: 0 3vw;
        height: 10vw;
        line-height: 10vw;
      }
    }
    .input-upload {
      border: 1px solid #666666;
      border-radius: 5px;
      width: 94vw;
      margin: 0 3vw;
      font-weight: bold;
      color: #1d84ff;
      margin-bottom: 10px;
    }
  }
  .btn-group {
    width: 100%;
    padding: 10px 0;
    text-align: center;
    background-color: #fff;
    position: fixed;
    bottom: 0;
    display: flex;
    justify-content: space-around;
    // box-shadow: 0px -5px 5px -5px #ccc;
    border-top: 1px solid #eee;
    .btn {
      padding: 14px 20px;
      font-weight: 500;
      color: #ffffff;
      border: 1px solid transparent;
    }
  }

  .success-dialog {
    text-align: center;
    padding: 30px 0;
    img {
      width: 60px;
    }
    .text {
      font-size: large;
      font-weight: bold;
      padding-top: 10px;
    }
  }
}
</style>
